import {
  LoginUX,
  Monitor,
  PublicRoutes,
  IndexableRoutes,
  IndexablePrefixes,
} from '../constants';

export const isMonitoring = (route: string) =>
  Object.values(Monitor).some((monitor) => route.includes(monitor));

export const isLoginUX = (route: string) =>
  Object.values(LoginUX).some((loginUx) => route.includes(loginUx));

export const isPublicRoute = (route: string) =>
  Object.values(PublicRoutes).some((publicRoute) =>
    route.includes(publicRoute),
  );
// Requires an exact match for indexable
export const isIndexableRoute = (route: string) =>
  Object.values(IndexableRoutes).some(
    (indexableRoute) => route === indexableRoute,
  ) ||
  Object.values(IndexablePrefixes).some((indexablePrefix) =>
    route.startsWith(indexablePrefix),
  );
